module.exports = __webpack_public_path__ + "static/media/zielone.fc43130b.jpg";